var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindDirectionTomorrowio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    className: "weather-filter-parameter__icon--Huru",
    fill: "current",
    stroke: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4002,14.0324c0.3561-0.1427,0.7097,0.2112,0.5674,0.5674l-2.8491,7.1258 c-0.1545,0.3863-0.7101,0.3579-0.8249-0.0419l-0.886-3.0913l-3.0913-0.8864c-0.3998-0.1143-0.4282-0.6704-0.0419-0.8249 L21.4002,14.0324z M2,11.97C2,11.4343,2.4343,11,2.97,11h13.3158c0.6567,0,1.2405-0.6603,1.2405-1.53s-0.5838-1.53-1.2405-1.53 c-0.3875,0-0.7585,0.2272-0.9983,0.6264c-0.2758,0.4592-0.8718,0.6079-1.331,0.3321c-0.4592-0.2759-0.6079-0.8718-0.3321-1.331 C14.2026,6.6049,15.1902,6,16.2858,6c1.785,0,3.1805,1.5783,3.1805,3.47s-1.3956,3.47-3.1805,3.47H2.97 C2.4343,12.94,2,12.5057,2,11.97z M8.0227,14H2.97C2.4343,14,2,14.4343,2,14.97s0.4343,0.97,0.97,0.97h5.0527 c0.6567,0,1.2405,0.6602,1.2405,1.53S8.6794,19,8.0227,19c-0.4031,0-0.7886-0.2466-1.0256-0.6737 c-0.2599-0.4684-0.8503-0.6375-1.3188-0.3776s-0.6375,0.8503-0.3776,1.3188c0.5666,1.0212,1.585,1.6725,2.722,1.6725 c1.7849,0,3.1805-1.5784,3.1805-3.47S9.8076,14,8.0227,14z M2.97,9.94h5.2632c1.785,0,3.1805-1.5784,3.1805-3.47S10.0182,3,8.2332,3 c-0.527,0-1.0364,0.1403-1.4906,0.403C5.7028,4.0043,5.0526,5.1813,5.0526,6.47c0,0.5357,0.4343,0.97,0.97,0.97 s0.97-0.4343,0.97-0.97c0-0.6093,0.2932-1.1401,0.7211-1.3876C7.8766,4.9883,8.0518,4.94,8.2332,4.94 c0.6567,0,1.2405,0.6602,1.2405,1.53S8.8899,8,8.2332,8H2.97C2.4343,8,2,8.4343,2,8.97S2.4343,9.94,2.97,9.94z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindDirectionTomorrowio);
export default __webpack_public_path__ + "static/media/wind-direction-tomorrowio.87c5cc4c58adcb9e54e5a00d98b40173.svg";
export { ForwardRef as ReactComponent };